<template>
  <el-dialog title="命令下发" :visible.sync="dialogVisible" class="editDialog" width="50%">
    <el-form :model="form" label-width="0" class="config-form">
      <el-form-item label="设备名称" prop="deviceCode" label-width="100px">
        <el-select v-model="form.deviceCode" placeholder="请选择设备名称">
          <el-option
            v-for="item in deviceList"
            :key="item.id"
            :label="item.deviceName"
            :value="item.deviceId"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 上报频率 -->
      <el-form-item>
        <div class="form-row">
          <el-checkbox v-model="form.sendReportChecked"></el-checkbox>
          <span class="field-label">上报频率（分钟）：</span>
          <el-input v-model="form.sendFrequency" placeholder="请输入上报频率"></el-input>
        </div>
      </el-form-item>

      <!-- 主机电量 -->
      <el-form-item class="range-item">
        <div class="form-row">
          <el-checkbox v-model="form.electricChecked"></el-checkbox>
          <span class="field-label">主机电量：</span>
          <div class="range-inputs">
            <span class="label-text">最大值</span>
            <el-input v-model="form.electric.maxValue" placeholder="请输入最大值"></el-input>
            <span class="label-text">最小值</span>
            <el-input v-model="form.electric.minValue" placeholder="请输入最小值"></el-input>
          </div>
        </div>
      </el-form-item>

      <!-- 环境温度 -->
      <el-form-item class="range-item">
        <div class="form-row">
          <el-checkbox v-model="form.temperatureChecked"></el-checkbox>
          <span class="field-label">环境温度：</span>
          <div class="range-inputs">
            <span class="label-text">最大值</span>
            <el-input v-model="form.temperature.maxValue" placeholder="请输入最大值"></el-input>
            <span class="label-text">最小值</span>
            <el-input v-model="form.temperature.minValue" placeholder="请输入最小值"></el-input>
          </div>
        </div>
      </el-form-item>

      <!-- 环境湿度 -->
      <el-form-item class="range-item">
        <div class="form-row">
          <el-checkbox v-model="form.humidityChecked"></el-checkbox>
          <span class="field-label">环境湿度：</span>
          <div class="range-inputs">
            <span class="label-text">最大值</span>
            <el-input v-model="form.humidity.maxValue" placeholder="请输入最大值"></el-input>
            <span class="label-text">最小值</span>
            <el-input v-model="form.humidity.minValue" placeholder="请输入最小值"></el-input>
          </div>
        </div>
      </el-form-item>

      <!-- 舞动幅度 -->
      <el-form-item class="range-item">
        <div class="form-row">
          <el-checkbox v-model="form.scopeChecked"></el-checkbox>
          <span class="field-label">舞动幅度：</span>
          <div class="range-inputs">
            <span class="label-text">最大值</span>
            <el-input v-model="form.scope.maxValue" placeholder="请输入最大值"></el-input>
            <span class="label-text">最小值</span>
            <el-input v-model="form.scope.minValue" placeholder="请输入最小值"></el-input>
          </div>
        </div>
      </el-form-item>

      <!-- 舞动频率 -->
      <el-form-item class="range-item">
        <div class="form-row">
          <el-checkbox v-model="form.frequencyChecked"></el-checkbox>
          <span class="field-label">舞动频率：</span>
          <div class="range-inputs">
            <span class="label-text">最大值</span>
            <el-input v-model="form.frequency.maxValue" placeholder="请输入最大值"></el-input>
            <span class="label-text">最小值</span>
            <el-input v-model="form.frequency.minValue" placeholder="请输入最小值"></el-input>
          </div>
        </div>
      </el-form-item>

      <!-- L01电流 -->
      <el-form-item class="range-item">
        <div class="form-row">
          <el-checkbox v-model="form.L01CurrentChecked"></el-checkbox>
          <span class="field-label">L01电流：</span>
          <div class="range-inputs">
            <span class="label-text">最大值</span>
            <el-input v-model="form.L01CurrentValue.maxValue" placeholder="请输入最大值"></el-input>
            <span class="label-text">最小值</span>
            <el-input v-model="form.L01CurrentValue.minValue" placeholder="请输入最小值"></el-input>
          </div>
        </div>
      </el-form-item>

      <!-- L01温度 -->
      <el-form-item class="range-item">
        <div class="form-row">
          <el-checkbox v-model="form.L01TemperatureChecked"></el-checkbox>
          <span class="field-label">L01温度：</span>
          <div class="range-inputs">
            <span class="label-text">最大值</span>
            <el-input v-model="form.L01Temperature.maxValue" placeholder="请输入最大值"></el-input>
            <span class="label-text">最小值</span>
            <el-input v-model="form.L01Temperature.minValue" placeholder="请输入最小值"></el-input>
          </div>
        </div>
      </el-form-item>

      <!-- L02电流 -->
      <el-form-item class="range-item">
        <div class="form-row">
          <el-checkbox v-model="form.L02CurrentChecked"></el-checkbox>
          <span class="field-label">L02电流：</span>
          <div class="range-inputs">
            <span class="label-text">最大值</span>
            <el-input v-model="form.L02CurrentValue.maxValue" placeholder="请输入最大值"></el-input>
            <span class="label-text">最小值</span>
            <el-input v-model="form.L02CurrentValue.minValue" placeholder="请输入最小值"></el-input>
          </div>
        </div>
      </el-form-item>

      <!-- L02温度 -->
      <el-form-item class="range-item">
        <div class="form-row">
          <el-checkbox v-model="form.L02TemperatureChecked"></el-checkbox>
          <span class="field-label">L02温度：</span>
          <div class="range-inputs">
            <span class="label-text">最大值</span>
            <el-input v-model="form.L02Temperature.maxValue" placeholder="请输入最大值"></el-input>
            <span class="label-text">最小值</span>
            <el-input v-model="form.L02Temperature.minValue" placeholder="请输入最小值"></el-input>
          </div>
        </div>
      </el-form-item>

      <!-- L11电流 -->
      <el-form-item class="range-item">
        <div class="form-row">
          <el-checkbox v-model="form.L11CurrentChecked"></el-checkbox>
          <span class="field-label">L11电流：</span>
          <div class="range-inputs">
            <span class="label-text">最大值</span>
            <el-input v-model="form.L11CurrentValue.maxValue" placeholder="请输入最大值"></el-input>
            <span class="label-text">最小值</span>
            <el-input v-model="form.L11CurrentValue.minValue" placeholder="请输入最小值"></el-input>
          </div>
        </div>
      </el-form-item>

      <!-- L11温度 -->
      <el-form-item class="range-item">
        <div class="form-row">
          <el-checkbox v-model="form.L11TemperatureChecked"></el-checkbox>
          <span class="field-label">L11温度：</span>
          <div class="range-inputs">
            <span class="label-text">最大值</span>
            <el-input v-model="form.L11Temperature.maxValue" placeholder="请输入最大值"></el-input>
            <span class="label-text">最小值</span>
            <el-input v-model="form.L11Temperature.minValue" placeholder="请输入最小值"></el-input>
          </div>
        </div>
      </el-form-item>

      <!-- L12电流 -->
      <el-form-item class="range-item">
        <div class="form-row">
          <el-checkbox v-model="form.l12CurrentChecked"></el-checkbox>
          <span class="field-label">L12电流：</span>
          <div class="range-inputs">
            <span class="label-text">最大值</span>
            <el-input v-model="form.L12CurrentValue.maxValue" placeholder="请输入最大值"></el-input>
            <span class="label-text">最小值</span>
            <el-input v-model="form.L12CurrentValue.minValue" placeholder="请输入最小值"></el-input>
          </div>
        </div>
      </el-form-item>

      <!-- L12温度 -->
      <el-form-item class="range-item">
        <div class="form-row">
          <el-checkbox v-model="form.L12TemperatureChecked"></el-checkbox>
          <span class="field-label">L12温度：</span>
          <div class="range-inputs">
            <span class="label-text">最大值</span>
            <el-input v-model="form.L12Temperature.maxValue" placeholder="请输入最大值"></el-input>
            <span class="label-text">最小值</span>
            <el-input v-model="form.L12Temperature.minValue" placeholder="请输入最小值"></el-input>
          </div>
        </div>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: 'configDialog',
    data() {
      return {
        dialogVisible: this.visible,
        form: {
          deviceCode: '',
          sendFrequency: '',
          sendReportChecked: false,
          electric: { maxValue: '', minValue: '' },
          electricChecked: false,
          temperature: { maxValue: '', minValue: '' },
          temperatureChecked: false,
          humidity: { maxValue: '', minValue: '' },
          humidityChecked: false,
          scope: { maxValue: '', minValue: '' },
          scopeChecked: false,
          frequency: { maxValue: '', minValue: '' },
          frequencyChecked: false,
          L01CurrentValue: { maxValue: '', minValue: '' },
          L01CurrentChecked: false,
          L01Temperature: { maxValue: '', minValue: '' },
          L01TemperatureChecked: false,
          L02CurrentValue: { maxValue: '', minValue: '' },
          L02CurrentChecked: false,
          L02Temperature: { maxValue: '', minValue: '' },
          L02TemperatureChecked: false,
          L11CurrentValue: { maxValue: '', minValue: '' },
          L11CurrentChecked: false,
          L11Temperature: { maxValue: '', minValue: '' },
          L11TemperatureChecked: false,
          L12CurrentValue: { maxValue: '', minValue: '' },
          L12CurrentChecked: false,
          L12Temperature: { maxValue: '', minValue: '' },
          L12TemperatureChecked: false
        },
        deviceList: []
      }
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      visible: {
        handler(val) {
          this.dialogVisible = val
          if (val) {
            this.form = {
              deviceCode: '',
              sendFrequency: '',
              sendReportChecked: false,
              electric: { maxValue: '', minValue: '' },
              electricChecked: false,
              temperature: { maxValue: '', minValue: '' },
              temperatureChecked: false,
              humidity: { maxValue: '', minValue: '' },
              humidityChecked: false,
              scope: { maxValue: '', minValue: '' },
              scopeChecked: false,
              frequency: { maxValue: '', minValue: '' },
              frequencyChecked: false,
              L01CurrentValue: { maxValue: '', minValue: '' },
              L01CurrentChecked: false,
              L01Temperature: { maxValue: '', minValue: '' },
              L01TemperatureChecked: false,
              L02CurrentValue: { maxValue: '', minValue: '' },
              L02CurrentChecked: false,
              L02Temperature: { maxValue: '', minValue: '' },
              L02TemperatureChecked: false,
              L11CurrentValue: { maxValue: '', minValue: '' },
              L11CurrentChecked: false,
              L11Temperature: { maxValue: '', minValue: '' },
              L11TemperatureChecked: false,
              L12CurrentValue: { maxValue: '', minValue: '' },
              L12CurrentChecked: false,
              L12Temperature: { maxValue: '', minValue: '' },
              L12TemperatureChecked: false
            }
            this.getDeviceList()
          }
        },
        immediate: true
      },
      dialogVisible(val) {
        this.$emit('update:visible', val)
      }
    },
    methods: {
      getDeviceList() {
        this.$axiosget('operation/gapStick/deviceList').then(res => {
          if (res.data.status == 10000) {
            this.deviceList = res.data.data
          }
        })
      },
      isValidNumber(value) {
        if (!value) return false
        const num = parseFloat(value)
        return !isNaN(num) && /^-?\d+(\.\d+)?$/.test(value)
      },
      handleClose() {
        this.dialogVisible = false
        this.$emit('close')
      },
      handleConfirm() {
        if (!this.form.deviceCode) {
          this.$message({
            type: 'warning',
            message: '请选择设备'
          })
          return
        }
        const hasAnyChecked =
          this.form.sendReportChecked ||
          this.form.electricChecked ||
          this.form.temperatureChecked ||
          this.form.humidityChecked ||
          this.form.scopeChecked ||
          this.form.frequencyChecked ||
          this.form.L01CurrentChecked ||
          this.form.L01TemperatureChecked ||
          this.form.L02CurrentChecked ||
          this.form.L02TemperatureChecked ||
          this.form.L11CurrentChecked ||
          this.form.L11TemperatureChecked ||
          this.form.L12CurrentChecked ||
          this.form.L12TemperatureChecked

        if (!hasAnyChecked) {
          this.$message({
            type: 'warning',
            message: '请至少选择一个配置项'
          })
          return
        }
        const validationErrors = []
        // 校验上报频率
        if (this.form.sendReportChecked && !this.form.sendFrequency) {
          validationErrors.push('请输入上报频率')
        } else if (
          this.form.sendReportChecked &&
          this.form.sendFrequency &&
          !this.isValidNumber(this.form.sendFrequency)
        ) {
          validationErrors.push('上报频率必须为整数或小数')
        }

        // 校验范围类型字段
        const rangeFields = [
          { checked: 'electricChecked', data: 'electric', label: '主机电量' },
          { checked: 'temperatureChecked', data: 'temperature', label: '环境温度' },
          { checked: 'humidityChecked', data: 'humidity', label: '环境湿度' },
          { checked: 'scopeChecked', data: 'scope', label: '舞动幅度' },
          { checked: 'frequencyChecked', data: 'frequency', label: '舞动频率' },
          { checked: 'L01CurrentChecked', data: 'L01Current', label: 'L01电流' },
          { checked: 'L01TemperatureChecked', data: 'L01Temperature', label: 'L01温度' },
          { checked: 'L02CurrentChecked', data: 'L02Current', label: 'L02电流' },
          { checked: 'L02TemperatureChecked', data: 'L02Temperature', label: 'L02温度' },
          { checked: 'L11CurrentChecked', data: 'L11Current', label: 'L11电流' },
          { checked: 'L11TemperatureChecked', data: 'L11Temperature', label: 'L11温度' },
          { checked: 'L12CurrentChecked', data: 'L12Current', label: 'L12电流' },
          { checked: 'L12TemperatureChecked', data: 'L12Temperature', label: 'L12温度' }
        ]

        rangeFields.forEach(field => {
          if (this.form[field.checked]) {
            const data = this.form[field.data]
            const hasMax = data.maxValue && data.maxValue.trim() !== ''
            const hasMin = data.minValue && data.minValue.trim() !== ''

            // 如果都没填，提示错误
            if (!hasMax && !hasMin) {
              validationErrors.push(`${field.label}的最大值或最小值至少需要填写一个`)
              return
            }

            // 检查填写的值是否为有效数值
            if (hasMax && !this.isValidNumber(data.maxValue)) {
              validationErrors.push(`${field.label}的最大值必须为有效的整数或小数`)
              return
            }
            if (hasMin && !this.isValidNumber(data.minValue)) {
              validationErrors.push(`${field.label}的最小值必须为有效的整数或小数`)
              return
            }

            // 如果max和min都填写了，检查最小值是否小于最大值
            if (hasMax && hasMin) {
              const maxNum = parseFloat(data.maxValue)
              const minNum = parseFloat(data.minValue)
              if (minNum >= maxNum) {
                validationErrors.push(`${field.label}的最小值必须小于最大值`)
              }
            }
          }
        })

        // 如果有校验错误，提示用户
        if (validationErrors.length > 0) {
          this.$message({
            type: 'warning',
            message: validationErrors[0]
          })
          return
        }

        const result = {}
        if (this.form.sendReportChecked) {
          result.sendFrequency = this.form.sendFrequency
        }

        rangeFields.forEach(field => {
          if (this.form[field.checked]) {
            const data = this.form[field.data]
            const fieldResult = {}
            // 只添加有值的max或min
            if (data.maxValue && data.maxValue.trim() !== '') {
              fieldResult.maxValue = data.maxValue
            }
            if (data.minValue && data.minValue.trim() !== '') {
              fieldResult.minValue = data.minValue
            }
            result[field.data] = fieldResult
          }
        })

        this.$emit('confirm', {
          data: result,
          deviceCode: this.form.deviceCode
        })
        // this.handleClose()
      }
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .config-form {
    .el-form-item__content {
      display: flex;
      align-items: center;
    }

    .form-row {
      display: flex;
      align-items: center;
      gap: 10px;
      width: 100%;
    }

    .field-label {
      color: #fff;
      font-size: 14px;
      white-space: nowrap;
      min-width: 72px;
    }

    .range-inputs {
      display: flex;
      align-items: center;
      gap: 10px;
      width: 100%;
    }

    .el-input {
      flex: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/spaceBarData/configDialog.vue